import React from "react"
import {useLocal} from "../../AppContext"
import {ConditionsBudget} from "../../Components/ConditionsBudget"
import {ConditionsFireProtection} from "../../Components/ConditionsFireProtection"
import {ConditionsNoise} from "../../Components/ConditionsNoise"
import {PlanningName} from "../../Components/PlanningName"
import {RoomLabel} from "../../Components/RoomLabel"
import {RoomSize} from "../../Components/RoomSize"
import {PlanningCode} from "../../Components/PlanningCode"
import style from "./Info.css"

export const Info = ({title, encouragement, bright = false, fullWidth = false}) => {
    const local = useLocal()
    const className = bright ? `${style.block} ${style.bright}` : style.block
    return <div className={className}>
        {title ? <div className={style.title}>{title}</div> : ''}
        <div className={fullWidth ? style.fullWidth : ''}>
            {encouragement ? <div className={style.encouragement} dangerouslySetInnerHTML={{__html: encouragement}}/> : ''}
            <div className={style.properties}>
                <div>{local.__("Ihr Raumcode:")}</div>
                <div><PlanningCode/></div>
                <div>{local.__("Ihr Planung:")}</div>
                <div><PlanningName/></div>
                <div>{local.__("Ihr Raum:")}</div>
                <div><RoomLabel/>, <RoomSize/></div>
                <div>{local.__("Lärmquellen:")}</div>
                <div><ConditionsNoise/></div>
                <div>{local.__("Preisfenster:")}</div>
                <div><ConditionsBudget/></div>
                <div>{local.__("Brandshutz:")}</div>
                <div><ConditionsFireProtection/></div>
            </div>
        </div>
    </div>
}